import { provideBrowserGlobalErrorListeners } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';

platformBrowser()
    .bootstrapModule(AppModule, {
        applicationProviders: [provideBrowserGlobalErrorListeners()],
    })
    .catch((err: unknown) => {
        // eslint-disable-next-line no-console
        console.error(err);
    });
